import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export function useLocalStorage(
    key: string,
    initialValue: string
): [string, Dispatch<SetStateAction<string>>] {
    const [value, setValue] = useState(
        localStorage.getItem(key) ?? initialValue
    );

    const setHandler = useCallback<Dispatch<SetStateAction<string>>>(
        (v) => {
            const newValue = v instanceof Function ? v(value) : v;
            localStorage.setItem(key, newValue);
            setValue(newValue);
        },
        [key, value]
    );

    return [value, setHandler];
}
